import { AlertCircle } from "lucide-react";
import Link from "next/link";

interface Props {
  onButtonClick: () => void;
}

export const PurchaseFailed = ({ onButtonClick }: Props) => {
  return (
    <div className="px-6 pt-4 pb-12 md:py-28 md:px-52 flex flex-col gap-8">
      <div className="flex flex-col items-center gap-8 md:w-[500px]">
        <div className="flex flex-col gap-6 items-center w-full">
          <div className="flex flex-col gap-3 items-center">
            <div className="flex flex-row gap-1 bg-[#FEF2F1] p-4 rounded-full">
              <AlertCircle className="w-8 h-8 text-[#EE3233]" />
            </div>
            <h1 className="text-primary-blue text-xl md:text-2xl font-bold font-sans normal-case">
              Order could not be completed.
            </h1>
          </div>
        </div>
        <p className="text-secondary-blue font-light text-center">
          Something went wrong and we couldn&apos;t complete your purchase.
          Please try again or contact support if the issue persists.
        </p>
        <button
          type="button"
          className="btn w-full py-3.5 text-[14px] font-semibold"
          onClick={onButtonClick}
        >
          Try again
        </button>
        <Link
          href="mailto:hello@punchup.live"
          className="text-primary font-bold underline underline-offset-2"
        >
          Contact support
        </Link>
      </div>
    </div>
  );
};
